import { createStore, useStore } from 'zustand';

import { RouteName } from '@lib/types';

import { getDefaultScreen } from './getDefaultScreen';

interface NavigationStore {
  currentRoute: RouteName;
  setCurrentRoute: (route: RouteName) => void;
}

export const navigationStore = createStore<NavigationStore>((set) => ({
  currentRoute: getDefaultScreen(),
  setCurrentRoute: (currentRoute) => {
    set({ currentRoute });
  },
}));

export const useNavigationStore = () => useStore(navigationStore);
